var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import PriceBarMobile from './PriceBarMobile';
import PriceBarTablet from './PriceBarTablet';
import PriceBarDesktop from './PriceBarDesktop';
import getTestId from '@idp/ui-components/utils';
var PriceBar = /** @class */ (function (_super) {
    __extends(PriceBar, _super);
    function PriceBar(props) {
        var _this = _super.call(this, props) || this;
        _this.updateWidth = _this.updateWidth.bind(_this);
        _this.state = { currentWidth: window.innerWidth };
        return _this;
    }
    PriceBar.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.updateWidth);
    };
    PriceBar.prototype.render = function () {
        return this.state.currentWidth < 768 ? (React.createElement(PriceBarMobile, __assign({ testId: getTestId(this.props.testId, 'PriceBarMobile') }, this.props))) : this.state.currentWidth < 1025 ? (React.createElement(PriceBarTablet, __assign({ testId: getTestId(this.props.testId, 'PriceBarTablet') }, this.props))) : (React.createElement(PriceBarDesktop, __assign({ testId: getTestId(this.props.testId, 'PriceBarDesktop') }, this.props)));
    };
    PriceBar.prototype.updateWidth = function () {
        this.setState(function () { return ({ currentWidth: window.innerWidth }); });
    };
    return PriceBar;
}(React.Component));
export default PriceBar;
//# sourceMappingURL=PriceBar.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/PriceBar/PriceBarSub/PriceBar.js
// module id = 2222
// module chunks = 8